import Hero from './components/Hero';
import About from './components/About';
import AvailableKittens from './components/AvailableKittens';
import WhyAdopt from './components/WhyAdopt';
import AdoptionProcess from './components/AdoptionProcess';
import HealthCare from './components/HealthCare';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <AvailableKittens />
      <WhyAdopt />
      <AdoptionProcess />
      <HealthCare />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
